import React, { useState, useEffect } from 'react';
import { Checkbox, Input, Box, styled, css, Flex } from '../design-system';
import { Button } from '../design-system';
import Loadable from './Loadable';

const SelectedCount = styled.small(
  ({ theme }) => css`
    color: ${theme.colors.greyLight};
    margin-left: 8px;
  `,
);

const CheckboxGroupContainer = styled.div(
  ({ theme }) => css`
    min-height: 250px;
    overflow: scroll;
    background: white;
    padding: 10px 10px 0 10px;
    border-radius: 8px;
    border: 1px solid ${theme.colors.greyLight};
  `,
);

interface Choice {
  value: any;
  label: string;
}

interface CheckboxGroupFieldProps {
  label?: string;
  choices: Choice[];
  onChange: (name: string, value: any[]) => void;
  value?: any[];
  name?: string;
  [key: string]: any;
}

const CheckboxGroupField = ({
  label: labelIn,
  choices: choicesIn,
  onChange,
  value: valuesIn = [],
  ...props
}: CheckboxGroupFieldProps) => {
  // Fully controlled: the form value is the single source of truth, so
  // external changes (form reset, filter clearing, reopening with new
  // initial values) are always reflected.
  const selected = Array.isArray(valuesIn) ? valuesIn : [];
  const [searchInput, setInput] = useState('');
  const [choices, setChoices] = useState(choicesIn);

  const handleSearch = (_name: string, value: string) => {
    setInput(value);
  };
  const handleSelectAll = () => {
    onChange(
      props.name,
      choicesIn.map(({ value }) => value),
    );
  };
  const handleUnselectAll = () => {
    onChange(props.name, []);
  };
  const handleChange = (value: any) => {
    const newSelected = selected.includes(value)
      ? selected.filter((v) => v !== value)
      : choicesIn
          .filter((c) => c.value === value || selected.includes(c.value))
          .map((c) => c.value);

    onChange(props.name, newSelected);
  };

  useEffect(() => {
    setChoices(
      choicesIn.filter(({ label: choiceLabel }) =>
        choiceLabel.toUpperCase().includes(searchInput.toUpperCase()),
      ),
    );
    // handleSelectAll();
  }, [searchInput, choicesIn]);

  return (
    <>
      <Flex>
        {labelIn && (
          <p>
            {labelIn}
            <SelectedCount>{selected.length} selected</SelectedCount>
          </p>
        )}
      </Flex>
      <Flex mb={2}>
        <Box flex={2} mr={2}>
          <Input
            onChange={handleSearch}
            name="searchInput"
            value={searchInput}
            placeholder="Search Clients"
            rightIcon="close"
            rightIconProps={{
              onClick: () => setInput(''),
              color: searchInput ? 'primary' : 'greyLighter',
            }}
          />
        </Box>
        <Button.Group flex={1} alignItems="center">
          <Button size="lg" onClick={handleSelectAll}>
            Select All
          </Button>
          <Button size="lg" onClick={handleUnselectAll}>
            Clear All
          </Button>
        </Button.Group>
      </Flex>
      <CheckboxGroupContainer>
        <div>
          {choices.length == 0 && searchInput == '' ? (
            <div style={{ margin: '100px 0px' }}>
              <Loadable loading={true} />
            </div>
          ) : (
            <Flex flexWrap="wrap">
              {choices.length > 0
                ? choices.map((choice) => {
                    const { value, label: labelChoice } = choice;
                    const isChecked = selected.includes(value);
                    return (
                      <Box key={value} mr={2} mb={2} flex="1 0 45%">
                        <Checkbox
                          id={value}
                          name={value}
                          label={labelChoice}
                          value={isChecked}
                          onChange={() => handleChange(value)}
                          style={{ flex: '1 0 50%', alignItems: 'center' }}
                        />
                      </Box>
                    );
                  })
                : `No choices match "${searchInput}".`}
            </Flex>
          )}
        </div>
      </CheckboxGroupContainer>
    </>
  );
};

export default CheckboxGroupField;
